import React from 'react';
import { providerFetch, getChannelAuditDetail, getProviderListedChannel } from 'api/open';
import { Provider, UniProfile } from 'types/provider';
import { ChannelItem, Service } from 'types/common';
import { getProviderFormDetail } from 'api/applicationForm';
import { getLiveChannelList } from 'api/channel';

export type ProviderFullInfo = Partial<{
    basicInfo: Provider;
    uniProfile: UniProfile;
    listedChannel: ChannelItem[];
    servicesList: Service[];
}>;

const useProviderFullInfo = (id?: number): [ProviderFullInfo | undefined, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [item, setItem] = React.useState<ProviderFullInfo>();
    const fetchData = async () => {
        const data: ProviderFullInfo = {};
        try {
            setLoading(true);
            const basicInfoResult = await providerFetch(id!);
            if (!basicInfoResult.error) {
                data.basicInfo = basicInfoResult?.data?.data || {};
            }
            // const uniProfileResult = await getChannelAuditDetail({
            //     channelId: 1,
            //     providerId: id,
            //     step: 'REVIEW',
            // });
            const uniProfileResult = await getProviderFormDetail({
                allowAuth: false,
                channelId: 1,
                providerId: id,
                step: 'REVIEW',
            });
            if (!uniProfileResult.error) {
                data.uniProfile = uniProfileResult?.data?.data || {};
            }

            const providerListChannelResult = await getLiveChannelList();
            if (!providerListChannelResult.error) {
                data.listedChannel = providerListChannelResult?.data?.data || [];
            }

            if (!providerListChannelResult.error) {
                data.listedChannel = providerListChannelResult?.data?.data || [];
            }

            const servicesListResult: any = {
                code: 200,
                message: 'SUCCESS',
                data: [
                    {
                        id: 92,
                        providerId: 51,
                        name: 'Consultation',
                        description:
                            'An opportunity for potential patients to discuss their concerns or needs with a provider, or therapist, to determine if their services are a good fit and to receive initial advice or guidance. Many providers offer free or very affordable consultation services with potential patient leads.',
                        duration: 0,
                        type: 'Consultation',
                        price: 111.22,
                        telehealthType: '',
                        personAddress: '',
                        personCity: '',
                        personState: '',
                        personZip: '',
                        personType: '',
                        colorId: '3',
                        sendForm: null,
                        intakeqServiceId: null,
                    },
                    {
                        id: 93,
                        providerId: 51,
                        name: 'Prescription service',
                        description:
                            "A prescription service appointment with a provider typically involves a brief review of his/her existing patient's medical history, confirming the need for the prescription service, and issuing a new prescription. It may also involve evaluating any side effects or concerns related to the medication and ensuring that the visit notes is still appropriate for the patient's needs.",
                        duration: 15,
                        type: 'Prescription service',
                        price: null,
                        telehealthType: null,
                        personAddress: null,
                        personCity: null,
                        personState: null,
                        personZip: null,
                        personType: null,
                        colorId: null,
                        sendForm: null,
                        intakeqServiceId: null,
                    },
                    {
                        id: 94,
                        providerId: 51,
                        name: 'Follow-up visit',
                        description:
                            "A follow-up visit with a provider involves checking the progress of the patient's visit notes, assessing any new symptoms or concerns, and adjusting the visit note as needed to ensure optimal health outcomes.",
                        duration: 15,
                        type: 'Follow-up visit',
                        price: null,
                        telehealthType: 'Children (5-13 years old),Adolescents (13-18 years old)',
                        personAddress: '',
                        personCity: '',
                        personState: '',
                        personZip: '',
                        personType: 'Children (5-13 years old),Adolescents (13-18 years old)',
                        colorId: '1',
                        sendForm: null,
                        intakeqServiceId: null,
                    },
                    {
                        id: 281,
                        providerId: 51,
                        name: 'Initial visit - general',
                        description:
                            "An initial visit with a provider involves a medical history review, physical examination, and possibly diagnostic tests to evaluate a patient's health, identify issues, and develop a visit notes",
                        duration: 0,
                        type: 'Initial Visit',
                        price: 11.11,
                        telehealthType: '',
                        personAddress: '',
                        personCity: '',
                        personState: '',
                        personZip: '',
                        personType: '',
                        colorId: '2',
                        sendForm: null,
                        intakeqServiceId: null,
                    },
                    {
                        id: 283,
                        providerId: 51,
                        name: 'Initial visit - Klarity',
                        description:
                            "An initial visit with a provider involves a medical history review, physical examination, and possibly diagnostic tests to evaluate a patient's health, identify issues, and develop a visit notes.",
                        duration: 0,
                        type: 'Initial Visit',
                        price: 22.22,
                        telehealthType: '',
                        personAddress: '',
                        personCity: '',
                        personState: '',
                        personZip: '',
                        personType: '',
                        colorId: '2',
                        sendForm: null,
                        intakeqServiceId: null,
                    },
                    {
                        id: 284,
                        providerId: 51,
                        name: 'Initial visit - market place',
                        description:
                            "An initial visit with a provider involves a medical history review, physical examination, and possibly diagnostic tests to evaluate a patient's health, identify issues, and develop a visit notes.",
                        duration: 0,
                        type: 'Initial Visit',
                        price: 22.22,
                        telehealthType: '',
                        personAddress: '',
                        personCity: '',
                        personState: '',
                        personZip: '',
                        personType: '',
                        colorId: '2',
                        sendForm: null,
                        intakeqServiceId: null,
                    },
                ],
            };

            if (!servicesListResult.error) {
                data.servicesList = servicesListResult?.data || [];
            }

            setLoading(false);
            setItem(data);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (!loading && id) {
            fetchData();
        }
    }, [id]);

    return [item, loading, fetchData];
};

export default useProviderFullInfo;
